var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card-item shadowless", attrs: { "data-cy": "card-item" } },
    [
      _c("div", { staticClass: "card-item-header" }, [
        _c("div", { staticClass: "transaction-header-resume" }, [
          _c("div", { staticClass: "transaction-header-amount" }, [
            _c(
              "span",
              {
                staticClass: "content-title",
                attrs: { id: `${_vm.transaction._id}-amount` },
              },
              [_vm._v(" Monto: ")]
            ),
            _c("span", { attrs: { id: `${_vm.transaction._id}-amount` } }, [
              _vm._v(
                " " +
                  _vm._s(
                    `${
                      _vm.$i18n.locale === "cl" ? "$" : "S/"
                    } ${_vm.formatNumber(_vm.transaction.debtAmount)}`
                  ) +
                  " "
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "transaction-header-payments" },
            [
              _c("span", { staticClass: "content-title" }, [
                _vm._v(
                  _vm._s(
                    `Cuota${_vm.transactionPayments.length > 1 ? "s" : ""}: `
                  ) + " "
                ),
              ]),
              _vm._l(_vm.transaction.selectedPayments, function (operation) {
                return _c(
                  "div",
                  { key: operation.companyOperationId },
                  _vm._l(operation.payments, function (payment) {
                    return _c(
                      "b-tooltip",
                      {
                        key: payment.paymentNumber,
                        attrs: { position: "is-right", type: "is-light" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "is-pulled-left" },
                                      [
                                        _c("span", [
                                          _c("b", [_vm._v("Crédito:")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                operation.companyOperationId
                                              )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "is-pulled-left" },
                                      [
                                        _c("span", [
                                          _c("b", [_vm._v("Vencimiento:")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .dateToFormatedString(
                                                    payment.dueDate,
                                                    "DD MMMM YYYY"
                                                  )
                                                  .toLowerCase()
                                              )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    !_vm.currentUserIsClient
                                      ? _c(
                                          "div",
                                          { staticClass: "is-pulled-left" },
                                          [
                                            _c("span", [
                                              _c("b", [
                                                _vm._v("Inversionista:"),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(payment.investorName) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "content-value transaction-header-payment",
                          },
                          [_vm._v(_vm._s(`${payment.paymentNumber}`))]
                        ),
                      ]
                    )
                  }),
                  1
                )
              }),
            ],
            2
          ),
          _c("div", { staticClass: "transaction-header-payed" }, [
            _c("span", { staticClass: "content-title" }, [
              _vm._v("Fecha de pago: "),
            ]),
            _c("span", [
              _vm._v(
                _vm._s(_vm.formatDate(_vm.transaction.createdAt, "DD/MM/YYYY"))
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "transaction-header-status" },
            [
              _c(
                "b-tooltip",
                {
                  attrs: {
                    label: "Estado del pago",
                    position: "is-bottom",
                    type: "is-light",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tag med-size-text",
                      class: `${_vm.transaction.status.toLowerCase()}`,
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.transaction.statusTranslation) + " "
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm.$i18n.locale === "cl"
          ? _c("div", { staticClass: "transaction-header-details" }, [
              _c(
                "a",
                {
                  attrs: { id: `extend-${_vm.transaction._id}`, href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit(
                        "extend-transaction",
                        _vm.transaction._id
                      )
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass: "fa",
                    class: _vm.isExtended
                      ? "fa-minus-circle"
                      : "fa-plus-circle",
                  }),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "card-item-details clearfix transition-slow",
          class: { show: _vm.isExtended },
        },
        [
          _c(
            "div",
            {
              staticClass: "details-header",
              attrs: { "data-cy": "details-header" },
            },
            [
              _c("span", [
                _c("span", { staticClass: "has-text-weight-bold" }, [
                  _vm._v("Medio de pago: "),
                ]),
                _c("span", [
                  _vm._v(_vm._s(_vm.transaction.providerTranslation)),
                ]),
              ]),
              _c("span", [
                _c("span", { staticClass: "has-text-weight-bold" }, [
                  _vm._v("UF el día del pago: "),
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      ` $ ${_vm.formatNumber(
                        _vm.transaction.secondaryCurrencyFactor
                      )}`
                    )
                  ),
                ]),
              ]),
            ]
          ),
          _vm._l(_vm.transaction.selectedPayments, function (operation) {
            return _c(
              "div",
              {
                key: operation.companyOperationId,
                staticClass: "selected-operation",
                attrs: { "data-cy": "selected-operation" },
              },
              [
                _c("span", { staticClass: "med-size-text" }, [
                  _c(
                    "span",
                    { staticClass: "gloss-credit" },
                    [
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            label: `Número de operación crédito ${_vm.getOperationTypeTitle(
                              operation.type
                            )}`,
                            size: "is-small",
                            type: "is-white",
                            multilined: "",
                          },
                        },
                        [
                          operation.type === "MORTGAGE"
                            ? _c("span", [_vm._v("🏡")])
                            : _vm._e(),
                          operation.type === "COMPLEMENTARY"
                            ? _c("span", [_vm._v("💰")])
                            : _vm._e(),
                          operation.type === "PARKING"
                            ? _c("span", [_vm._v("🅿️")])
                            : _vm._e(),
                          _c("span", { staticClass: "has-text-weight-bold" }, [
                            _vm._v(" Nº "),
                          ]),
                          _vm._v(
                            " " + _vm._s(operation.companyOperationId) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "selected-payment-details" }, [
                  _c("div", { staticClass: "gloss" }, [
                    _c(
                      "span",
                      { staticClass: "gloss-payment has-text-weight-bold" },
                      [_vm._v("Cuota")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "gloss-monetary-sign has-text-weight-bold",
                      },
                      [
                        operation.type !== "COMPLEMENTARY"
                          ? _c(
                              "b-field",
                              { attrs: { grouped: "" } },
                              [
                                _c(
                                  "b-switch",
                                  {
                                    attrs: {
                                      "data-cy": `ufSwitch-${operation.paymentsNumbers}`,
                                      size: "is-small",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.updateMonetarySignShowing({
                                          uf: $event,
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "has-text-weight-bold" },
                                      [_vm._v(" UF ")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._l(operation.payments, function (payment) {
                  return _c(
                    "div",
                    {
                      key: payment.paymentNumber,
                      staticClass: "selected-payment",
                      class:
                        _vm.extendedPayment ===
                        `${operation.companyOperationId}-${payment.paymentNumber}`
                          ? "show"
                          : "",
                    },
                    [
                      _c("div", { staticClass: "selected-payment-details" }, [
                        _c(
                          "div",
                          {
                            staticClass: "gloss",
                            class:
                              _vm.extendedPayment ===
                              `${operation.companyOperationId}-${payment.paymentNumber}`
                                ? "show has-text-weight-bold"
                                : "",
                          },
                          [
                            _c("span", { staticClass: "gloss-payment" }, [
                              _vm._v(_vm._s(payment.paymentNumber)),
                            ]),
                            _c("span", { staticClass: "gloss-title" }, [
                              _vm._v("Total"),
                            ]),
                            _vm.monetarySignShowing === "UF"
                              ? _c(
                                  "span",
                                  { staticClass: "gloss-monetary-sign" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(
                                          payment.totalMonthlyPayment
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.monetarySignShowing === "CLP"
                              ? _c(
                                  "span",
                                  { staticClass: "gloss-monetary-sign" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        `$ ${_vm.formatNumber(
                                          payment.secondaryCurrencyTotalMonthlyPayment
                                        )}`
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "a",
                              {
                                staticClass: "gloss-button",
                                attrs: {
                                  id: `extend-${operation.companyOperationId}-${payment.paymentNumber}`,
                                  href: "#",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.extendPayment(
                                      `${operation.companyOperationId}-${payment.paymentNumber}`
                                    )
                                  },
                                },
                              },
                              [
                                _c("span", {
                                  staticClass: "fa",
                                  class:
                                    _vm.extendedPayment ===
                                    `${operation.companyOperationId}-${payment.paymentNumber}`
                                      ? "fa-minus-circle"
                                      : "fa-plus-circle",
                                }),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "detail-glosses clearfix transition-slow",
                            class:
                              _vm.extendedPayment ===
                              `${operation.companyOperationId}-${payment.paymentNumber}`
                                ? "show"
                                : "hide",
                          },
                          [
                            payment.amortization
                              ? _c("div", { staticClass: "gloss" }, [
                                  _c("span", { staticClass: "gloss-title" }, [
                                    _vm._v("Amortización"),
                                  ]),
                                  _vm.monetarySignShowing === "UF"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(
                                                payment.amortization
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.monetarySignShowing === "CLP"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            "$ " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  payment.secondaryCurrencyAmortization
                                                )
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            payment.interest
                              ? _c("div", { staticClass: "gloss" }, [
                                  _c("span", { staticClass: "gloss-title" }, [
                                    _vm._v("Interés"),
                                  ]),
                                  _vm.monetarySignShowing === "UF"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(payment.interest)
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.monetarySignShowing === "CLP"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            "$ " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  payment.secondaryCurrencyInterest
                                                )
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            payment.monthlyDebtorLifeInsurance
                              ? _c("div", { staticClass: "gloss" }, [
                                  _c("span", { staticClass: "gloss-title" }, [
                                    _vm._v("Desgravamen"),
                                  ]),
                                  _vm.monetarySignShowing === "UF"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(
                                                payment.monthlyDebtorLifeInsurance
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.monetarySignShowing === "CLP"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            "$ " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  payment.secondaryCurrencyMonthlyDebtorLifeInsurance
                                                )
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            payment.monthlyCodebtorLifeInsurance
                              ? _c("div", { staticClass: "gloss" }, [
                                  _c("span", { staticClass: "gloss-title" }, [
                                    _vm._v("Desg. codeudor"),
                                  ]),
                                  _vm.monetarySignShowing === "UF"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(
                                                payment.monthlyCodebtorLifeInsurance
                                              )
                                            ) + " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.monetarySignShowing === "CLP"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            "$ " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  payment.secondaryCurrencyMonthlyCodebtorLifeInsurance
                                                )
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            payment.monthlyFireInsurance
                              ? _c("div", { staticClass: "gloss" }, [
                                  _c("span", { staticClass: "gloss-title" }, [
                                    _vm._v("Seguro de incendio"),
                                  ]),
                                  _vm.monetarySignShowing === "UF"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(
                                                payment.monthlyFireInsurance
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.monetarySignShowing === "CLP"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            "$ " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  payment.secondaryCurrencyMonthlyFireInsurance
                                                )
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            !!payment.monthlyCreditInsurance
                              ? _c("div", { staticClass: "gloss" }, [
                                  _c("span", { staticClass: "gloss-title" }, [
                                    _vm._v("Seguro de crédito"),
                                  ]),
                                  _vm.monetarySignShowing === "UF"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(
                                                payment.monthlyCreditInsurance
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.monetarySignShowing === "CLP"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            "$ " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  payment.secondaryCurrencyMonthlyCreditInsurance
                                                )
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            !!payment.monthlyCreditInsurancePrize
                              ? _c("div", { staticClass: "gloss" }, [
                                  _c("span", { staticClass: "gloss-title" }, [
                                    _vm._v("Seguro de crédito (Premio)"),
                                  ]),
                                  _vm.monetarySignShowing === "CLP"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            "$ " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  payment.monthlyCreditInsurancePrize
                                                )
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            !!payment.monthlyCreditInsuranceExpenses
                              ? _c("div", { staticClass: "gloss" }, [
                                  _c("span", { staticClass: "gloss-title" }, [
                                    _vm._v("Seguro de crédito (Costo)"),
                                  ]),
                                  _vm.monetarySignShowing === "CLP"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            "$ " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  payment.monthlyCreditInsuranceExpenses
                                                )
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            payment.lateInterest
                              ? _c("div", { staticClass: "gloss" }, [
                                  _c("span", { staticClass: "gloss-title" }, [
                                    _vm._v("Interés penal"),
                                  ]),
                                  _vm.monetarySignShowing === "UF"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(
                                                payment.lateInterest
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.monetarySignShowing === "CLP"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            "$ " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  payment.secondaryCurrencyLateInterest
                                                )
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            payment.lateCharges
                              ? _c("div", { staticClass: "gloss" }, [
                                  _c("span", { staticClass: "gloss-title" }, [
                                    _vm._v("Gastos de cobranza"),
                                  ]),
                                  _vm.monetarySignShowing === "UF"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(
                                                payment.lateCharges
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.monetarySignShowing === "CLP"
                                    ? _c(
                                        "span",
                                        { staticClass: "gloss-monetary-sign" },
                                        [
                                          _vm._v(
                                            "$ " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  payment.secondaryCurrencyLateCharges
                                                )
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            )
          }),
        ],
        2
      ),
      _vm.$i18n.locale === "cl"
        ? _c(
            "div",
            {
              staticClass: "card-item-details clearfix transition-slow",
              class: { show: _vm.isExtended },
            },
            [
              _c("div", { staticClass: "details-header" }, [
                _c("span", [
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v("Valor total cuotas seleccionadas: "),
                  ]),
                  _c(
                    "span",
                    { attrs: { id: `${_vm.transaction._id}-detail-amount` } },
                    [
                      _vm._v(
                        " $ " +
                          _vm._s(_vm.formatNumber(_vm.transaction.debtAmount)) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details-header" }, [
                _c("span", [
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v("Saldo de billetera utilizado: "),
                  ]),
                  _c(
                    "span",
                    { attrs: { id: `${_vm.transaction._id}-wallet-amount` } },
                    [
                      _vm._v(
                        " $ " +
                          _vm._s(
                            _vm.formatNumber(_vm.transaction.usedClientBalance)
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details-header" }, [
                _c("span", [
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v("Monto a pagar: "),
                  ]),
                  _c(
                    "span",
                    { attrs: { id: `${_vm.transaction._id}-amount-to-pay` } },
                    [
                      _vm._v(
                        " $ " +
                          _vm._s(_vm.formatNumber(_vm.transaction.amount)) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm.transaction.receivedAmount
                ? _c("div", { staticClass: "details-header" }, [
                    _c("span", [
                      _c("span", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Monto recibido: "),
                      ]),
                      _c(
                        "span",
                        {
                          attrs: {
                            id: `${_vm.transaction._id}-received-amount`,
                          },
                        },
                        [
                          _vm._v(
                            " $ " +
                              _vm._s(
                                _vm.formatNumber(_vm.transaction.receivedAmount)
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.transaction.status === "REJECTED" ||
              _vm.transaction.status === "FAIL" ||
              _vm.transaction.status === "CANCELLED"
                ? _c("div", { staticClass: "details-header" }, [
                    _vm.transaction.receivedAmount
                      ? _c("span", [
                          _c("span", { staticClass: "has-text-weight-bold" }, [
                            _vm._v("Saldo generado: "),
                          ]),
                          _c(
                            "span",
                            {
                              attrs: {
                                id: `${_vm.transaction._id}-generated-balance`,
                              },
                            },
                            [
                              _vm._v(
                                " $ " +
                                  _vm._s(
                                    _vm.formatNumber(
                                      _vm.transaction.receivedAmount +
                                        _vm.transaction.usedClientBalance
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ])
                      : _c("span", [
                          _c("span", { staticClass: "has-text-weight-bold" }, [
                            _vm._v("Saldo generado: "),
                          ]),
                          _c(
                            "span",
                            {
                              attrs: {
                                id: `${_vm.transaction._id}-generated-balance`,
                              },
                            },
                            [
                              _vm._v(
                                " $ " +
                                  _vm._s(
                                    _vm.formatNumber(
                                      _vm.transaction.usedClientBalance
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                  ])
                : _vm._e(),
              _vm.transaction.status === "CONFIRMED" ||
              _vm.transaction.status === "CONSIGNABLE"
                ? _c("div", { staticClass: "details-header" }, [
                    _c("span", [
                      _c("span", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Saldo generado: "),
                      ]),
                      _c(
                        "span",
                        {
                          attrs: {
                            id: `${_vm.transaction._id}-generated-balance`,
                          },
                        },
                        [
                          _vm._v(
                            " $ " +
                              _vm._s(
                                _vm.formatNumber(
                                  _vm.transaction.receivedAmount -
                                    _vm.transaction.amount
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }